import React from 'react'
import { FormText} from 'reactstrap';
import Icon from '../styles/icon';

const ShowError = ({ msg, type }) => {
    const color = type === "2"? "success" :"danger" ;
    return (
        <FormText color={color}>
            <Icon icon="fa-exclamation-circle" />{' '}
            <span>
                {msg}
            </span>
        </FormText>
    )
}
export default ShowError;


// WEBPACK FOOTER //
// ./src/admin/ShowError.jsx